const menuItems = [
    {
      title: "Home",
      url: "/",
      cName: "nav-links"
    },
    {
      title: "Services",
      url: "/services",
      cName: "nav-links"
    },
    {
      title: "About",
      url: "/about",
      cName: "nav-links"
    },
    {
      title: "Contact",
      url: "/contact",
      cName: "nav-links"
    },
  ];
  
  export default menuItems;
  